// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","819":"BusinessProVisitorLazyComponent"}[chunkId] + "." + {"46":"ce3777a29fbe2e53cd81","819":"b53696bf12cbadbd5d31"}[chunkId] + ".js";
};